import React from 'react';
import people from '@/imgs/AnalysisSpec/people.png';
import talk from '@/imgs/AnalysisSpec/talk.png';
import './AnalysisSpec.css';

interface AnalysisSpecProps {
  fundName?: string;
  fundCode?: string;
  fundInfo?: any;
}

const AnalysisSpec: React.FC<AnalysisSpecProps> = ({
  fundName = '',
  fundCode = '',
  fundInfo = {}
}) => {
  return (
    <div className="analysis-spec-wrap relative mb-3 flex flex-col gap-0">
      {/* 头部区域 */}
      <div className="pb-[45px]">
        {/* 背景装饰图片 */}
        <div className="absolute inset-0 flex">
          <div className="flex-1"></div>
        </div>

        {/* 内容 */}
        <div className="relative z-10 mt-[10px] flex h-full items-center px-2 xs-400:px-6">
          <div
            className="background-100 h-[134px] w-[100px] min-w-[100px]"
            style={{ backgroundImage: `url(${people}) ` }}
          >
            {/* <img src={people} className="h-full w-full object-cover" alt="分析" /> */}
          </div>
          <div
            className="background-100 h-[124px] w-[237px]"
            style={{ backgroundImage: `url(${talk})` }}
          >
            <div className="mt-[18px] text-left text-xs leading-relaxed text-gray-900 xs-400:text-sm">
              <span className="pl-2">
                正在对<span className="font-bold">{fundName}</span>
              </span>
              <br />
              <span className="whitespace-nowrap pl-2 pr-1">（代码：{fundCode}）进行深度解读</span>
            </div>
          </div>
        </div>
      </div>

      {/* 基金信息卡片 */}
      <div className="absolute bottom-0 left-0 right-0 z-[11] rounded-b-lg border border-gray-200 bg-gradient-to-r from-[#E7EAFF] to-[#E7E5FF] p-3">
        <div className="grid grid-cols-2 gap-6">
          {/* 第一列 */}
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-xs text-gray-900">基金类型</span>
              <span className="text-xs font-semibold text-gray-900">
                {fundInfo && fundInfo.基金类型}
              </span>
            </div>
            <div className="flex items-center justify-between">
              <span className="whitespace-nowrap text-xs text-gray-900">跟踪指数</span>
              <span className="ml-1 truncate whitespace-nowrap text-xs font-semibold text-gray-900">
                {fundInfo && fundInfo.跟踪指数}
              </span>
            </div>
          </div>

          {/* 第二列 */}
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-xs text-gray-900">成立时间</span>
              <span className="text-xs font-semibold text-gray-900">
                {fundInfo && fundInfo.成立时间}
              </span>
            </div>
            {/* <div className="flex items-center justify-between">
              <span className="text-xs text-gray-900">管理费</span>
              <span className="text-xs font-semibold text-gray-900">
                {fundInfo && fundInfo.管理费}
              </span>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalysisSpec;
